import type { ComponentProps } from 'react';

type Props = ComponentProps<'div'>;

const CreateFormFile = ({ ...props }: Props) => {
  return <div {...props}></div>;
};

export default CreateFormFile;
